export default {
  message: {
    "error": "앗! 문제가 발생했습니다.",
    "Sorrysomeerrorsoccurred": "예상치 못한 오류가 발생했습니다. 언어를 변경하거나 앱을 종료하고 다시 시작해 볼 수 있습니다.",
    "quit": "종료",
    "language": "언어",
    "Youcanchangethelanguagehere": "여기서 언어를 변경할 수 있습니다!",
    "current": "현재",
    "home": "홈",
    "friends": "친구",
    "wallet": "지갑",
    "aboutus": "회사 소개",
    "Sharewithfriends": "친구와 공유하기",
    "copyFailure": "복사 실패",
    "copySuccess": "복사 성공",
    "Claimreward": "보상 받기",
    "DailyLogin": "매일 로그인",
    "noInvitationsYet": "아직 초대가 없습니다",
    "LoadMore": "더 로드하기",
    "WatchAD": "광고 보기",
    "continue": "계속하기",
    "Congratulations": "축하합니다",
    "MyFriends": "내 친구들",
    "Invitefriends": "친구 초대하기",
    "Invitepremiumfriends": "프리미엄 친구 초대하기",
    "DailyTasks": "일일 작업",
    "inviteDesc": "초대하는 친구마다 +{num} ${name}",
    "DailyTasksDesc": "작업을 완료하여 더 많은 에어드롭을 받으세요",
    "SponsorsandPartners": "스폰서 및 파트너",
    "Receivingwallet": "보상 지갑",
    "Enterwalletaddress": "{name} 지갑 주소 입력",
    "Claim": "보상 받기",
    "Booster": "부스터",
    "RentPeriod": "임대 기간",
    "days30": "30일",
    "Dailyprofit": "일일 수익",
    "Totalprofit": "총 수익",
    "Quantity": "수량",
    "RentPrice": "임대 가격",
    "RentMiner": "채굴기 임대",
    "Insufficient": "초대자가 충분하지 않습니다",
    "InsufficientMsg": "더 많은 액세서리를 얻으려면 {num} 친구를 초대해야 합니다.",
    "Settings": "설정",
    "copyid": "아이디 복사",
    "UpgradeSuccessfully": "업그레이드 성공",
    "Name": "이름",
    "userinfo": "사용자 정보",
    "disconnect": "연결 끊기",
    "Startmining": "채굴 시작",
    "Welcome": "{name}에 오신 것을 환영합니다",
    "Withdrawal": "출금",
    "Minimumamount": "최소 금액",
    "Networkfee": "네트워크 수수료",
    "Enteramount": "금액 입력",
    "Submit": "제출",
    "MinimumTip": "출금 금액이 너무 작습니다. 최소 출금 금액: {num}",
    "MaximumTip": "금액이 부족합니다. 최대 출금 금액: {num}",
    "SubmittedTip": "제출되었습니다. 30-60 근무일 내에 처리될 것으로 예상됩니다.",
    "WebSubmittedTip": "제출되었습니다. 가능한 한 빨리 처리하겠습니다.",
    "WithdrawStatus": "상태",
    "Submissiontime": "제출 시간",
    "WithdrawAwaitTip": "* 30-60 근무일 정도 소요될 것으로 예상됩니다. 친구를 더 초대하면 검토 과정이 빨라질 수 있습니다.",
    "WebWithdrawAwaitTip": "* 24-48시간 정도 소요될 것으로 예상됩니다. 친구를 더 초대하면 검토 과정이 빨라질 수 있습니다.",
    "Processing": "처리 중",
    "Success": "성공",
    "Rejection": "거절",
    "Amount": "금액",
    "Numberoffriends": "친구 수: {now}/{limit}",
    "InviteTip": "첫 출금을 하려면 {limit}명의 친구를 마이닝 앱에 초대해야 합니다.",
    "openonphone": "이 링크를 휴대폰에서 여세요.",
    "claimTip": "수령할 금액이 너무 작습니다. 최소 수령 가능 금액: {num}",
    "WalletBalance": "지갑 잔액",
    "Withdraw": "출금",
    "SetWalletAddress": "지갑 주소 설정",
    "WithdrawalRecord": "출금 기록",
    "Norecords": "기록이 없습니다",
    "Whatis": "{name}은 무엇인가요?",
    "All": "모두",
    "save": "저장",
    "successWithdrawal": "스캔 성공 {num}",
    "secondsago": "{time}초 전",
    "Loading": "로딩 중...",
    "PaymentConfirming": "거래 상태 확인 중...",
    "Check": "확인",
    "CheckFail": "거래가 완료되지 않았습니다. 5초 후에 다시 확인해주세요.",
    "Addname": "'{name}'을 이름에 추가하세요",
    "Restattcheck": "앱을 재시작하여 확인하세요",
    "Copyname": "'{name}' 복사",
    "SubmissionFailed": "제출 실패, 나중에 다시 시도해주세요",
    "WithdrawalReview": "출금 검토",
    "select_payment_method": "결제 방법 선택",
    "total_amount": "총 금액",
    "next_step": "다음 단계",
    "creating_order": "주문 생성 중...",
    "order_created": "주문 생성됨",
    "order_status": "주문 상태",
    "order_id": "주문 ID",
    "order_amount": "주문 금액",
    "order_status_desc": "주문 상태 설명",
    "payment_cancelled": "결제 취소됨",
    "opening_payment": "결제 진행 중...",
    "payment_success": "결제 성공",
    "payment_failed": "결제 실패",
    "payment_pending": "결제 보류 중",
    "payment_processing": "결제 처리 중",
    "create_order_failed": "주문 생성 실패",
    "creating_ton_order": "TON 주문 생성 중...",
    "check_payment_status": "결제 상태 확인 중...",
    "use_ton_payment": "TON 결제 사용",
    "connect_wallet": "지갑 연결",
    "start_transaction": "거래 시작",
    "address": "주소",
    "amount_ton": "금액 TON",
    "copy": "복사",
    "comment_memo": "메모 후원",
    "comment_memo_desc": "메모 후원을 입력해 주세요",
    "comment_memo_placeholder": "메모 후원 입력",
    "amount": "금액",
    "wallet_address": "지갑 주소",
    "you_can_choose_to_connect_wallet_to_pay": "결제를 위해 지갑을 연결할 수 있습니다",
    "or_manually_transfer_to_the_above_address": "또는 위 주소로 수동 이체 (금액과 메모는 정확히 같아야 합니다)",
    "transaction_success": "거래 성공",
    "transaction_failed": "거래 실패",
    "transaction_error": "거래 오류",
    "transaction_status": "거래 상태",
    "transaction_id": "거래 ID",
    "transaction_amount": "거래 금액",
    "transaction_status_desc": "거래 상태 설명",
    "miner_detail": "채굴자 세부 정보",
    "rent_period": "임대 기간",
    "days": "{days} 일",
    "daily_yield": "일일 수익",
    "total_yield": "총 수익",
    "invite_friends": "친구 초대",
    "price": "가격",
    "rent": "임대",
    "free_claim": "무료 보상 받기",
    "redeem": "환전",
    "buy": "임대",
    "invite_friends_not_enough": "친구 초대 부족",
    "redeem_success": "환전 성공",
    "redeem_failed": "환전 실패",
    "rent_success": "임대 성공",
    "rent_failed": "임대 실패",
    "TotalPower": "총 파워",
    "MaxQuantity": "최대 값 도달",
    "Running": "실행 중",
    "Stop": "중지",
    "Withdrawalunlock": "출금 잠금 해제",
    "Close": "닫기",
    "Delivering": "전송 중",
    "Duetothelargenumber": "수신자가 많아 귀하의 에어드랍은 15-20 영업일 이내에 도착할 것으로 예상됩니다",
    "WithdrawalunlockTip": "출금을 해제하려면 {num}명의 초대받은 친구가 필요합니다",
    "mining_title": "로봇",
    "Upgrade": "업그레이드",
    "partner": "파트너",
    "faq": "자주 묻는 질문",
    "task": "작업",
    "OpenRobot": "로봇 열기",
    "MyRobot": "내 로봇",
    "Level": "레벨",
    "Commission": "수수료",
    "DirectFriends": "직접 친구들",
    "Feedback": "피드백",
    "Pleaseenteryouremailaddress": "이메일 주소를 입력하세요",
    "Inputfeedbackcontent": "피드백 내용을 입력하세요",
    "Submitfeedback": "피드백 제출하기",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "피드백이 성공적으로 제출되었습니다. 소중한 피드백에 감사합니다.",
    "Feedbacksubmissionfailed,pleaseretriy": "피드백 제출 실패, 다시 시도해 주세요",
    "Addressformaterror": "주소 형식 오류",
    "Readclipboardfailed": "클립보드 읽기 실패",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "오늘 이미 피드백을 남기셨습니다. 내일 다시 오세요.",
    "Record": "기록",
    "Newuserguidance": "환영 투어 보기",
    "Usetonwallet": "TON 지갑 사용하기",
    "Reward": "보상",
    "Connectwallet": "지갑 연결하기",
    "Notconnected": "연결되지 않음",
    "Disconnect": "연결 해제",
    "AboutTAI": "토큰 세부정보",
    "WithdrawalRecordDesc": "출금 기록",
    "StartAItrading": "AI 거래 시작",
    "Next": "다음",
    "Start": "시작",
    "WithdrawalSuccess": "출금 성공",
    "WithdrawalFail": "출금 실패",
    "Max": "최대",
    "WithdrawalRecords": "출금 기록",
    "Commissionrules": "수수료 규칙",
    "Mycommission": "내 수수료",
    "Shop": "상점",
    "BuyDifferentAIrobots": "더 빠른 스캔을 위해 컴퓨트 장치로 업그레이드하세요!",
    "CurrentRunningAIrobots": "현재 실행 중인 AI 로봇",
    "DailyProfit": "일일 수익",
    "Buy": "구매",
    "ValidityPeriod": "유효 기간",
    "Days": "일",
    "Price": "가격",
    "APY": "APY",
    "NoRobot": "컴퓨트 파워 없음",
    "RemainingTime": "남은 시간",
    "InviteandEarn": "초대 및 수익",
    "InvitDec": "친구를 초대하여 AI 거래에 참여하고 USDT 수수료와 에어드롭 토큰을 함께 받으세요!",
    "ShareToGroups": "그룹에 공유",
    "Select_payment_method": "결제 방법 선택",
    "twa_pay_tip_with_memo": "주소, 금액 및 메모가 전송에 일치하는지 확인하세요.",
    "twa_pay_tip": "주소와 금액이 전송에 올바른지 확인하세요.",
    "twa_pay_tip_placeholder": "댓글 메모 입력",
    "twa_pay_tip_placeholder_with_memo": "메모와 함께 댓글 메모 입력",
    "twa_pay_tip_placeholder_without_memo": "메모 없이 댓글 메모 입력",
    "twa_pay_tip_placeholder_with_memo_placeholder": "메모와 함께 댓글 메모 입력",
    "twa_pay_tip_placeholder_without_memo_placeholder": "메모 없이 댓글 메모 입력",
    "realtime_ai": "실시간 AI 트레이딩",
    "check_transaction_status": "거래 상태 확인",
    "transaction_wait": "거래가 처리 중입니다. 앱을 종료할 수 있습니다. 완료되면 알림 메시지가 전송됩니다.",
    "Pleaseenteravalidemailaddress": "유효한 이메일 주소를 입력하세요",
    "max_robot_tip": "구매 한도에 도달했습니다 — 거래를 계속하려면 다른 요금을 시도하세요!",
    "connectFailure": "지갑 연결 실패",
    "connectSuccess": "지갑 연결 성공",
    "PayNow": "지금 결제하기",
    "min_withdrawal_amount": "최소 출금 금액은 {num} {coin_name}입니다.",
    "max_withdrawal_amount": "최대 출금 금액은 {num} {coin_name}입니다.",
    "balance_not_enough": "이 출금을 위한 잔액이 부족합니다.",
    "Numberofgroups": "그룹 수: {now}/{limit}",
    "Withdraw_success": "출금 성공",
    "allProfit": "총 이익",
    "AnnualProfit": "연간 수익",
    "ScanWallet": "지갑 스캔",
    "wallet_check": "wallet_check",
    "Found": "발견됨",
    "ScanSpeed": "스캔 속도",
    "MyComputingPower": "컴퓨트",
    "Scanning": "스캔 중!",
    "WithdrawDetail": "출금 상세정보",
    "ScanSuccess": "당신의 스캔 성공률이 증가했습니다!",
    "TaskDescription": "작업을 완료하여 스캔 성공률을 높이세요!",
    "InitializingMiningSystem": "스캔 시스템 초기화 중...",
    "NoWithdrawalRecord": "출금 기록 없음",
    "Invite": "필요한 초대 수",
    "Free": "무료",
    "Confirm": "확인",
    "RefreshTasks": "작업 새로 고침",
    "NumberofGroups": "그룹 수: {now}/{limit}",
    "SendMessage": "메시지 보내기",
    "NumberofShares": "공유 수: {now}/{limit}",
    "NumberofTasks": "작업 수: {now}/{limit}",
    "CompleteTask": "작업 완료",
    "Accelerated": "가속화됨",
    "Accelerated_withdrawals_success": "가속화된 인출이 성공적으로 완료되었습니다",
    "GoBuy": "구매하기",
    "SpeedUpScan": "속도를 높이세요",
    "Earnings": "수익",
    "learnMore": "자세히 알아보기",
    "claimSuccess": "보상을 성공적으로 받았습니다",
    "claimFailed": "보상 받기에 실패했습니다. 다시 시도해 주세요",
    "noDividends": "받을 배당금이 없습니다",
    "dividendsInfoFallback": "친구를 초대하여 추천 보상을 얻으세요"
}};